export const ActiveAppletVideoPlay = 'Applet.ActiveAppletVideoPlay';
export interface ActiveAppletVideoPlay {
	type: typeof ActiveAppletVideoPlay;
	appletUid: string;
	timingChecksum: string;
	data: {
		uri: string;
		x: number;
		y: number;
		width: number;
		height: number;
	};
}

export const ActiveAppletVideoPrepare = 'Applet.ActiveAppletVideoPrepare';
export interface ActiveAppletVideoPrepare {
	type: typeof ActiveAppletVideoPrepare;
	appletUid: string;
	timingChecksum: string;
	data: {
		uri: string;
		x: number;
		y: number;
		width: number;
		height: number;
	};
}

export const ActiveAppletVideoStop = 'Applet.ActiveAppletVideoStop';
export interface ActiveAppletVideoStop {
	type: typeof ActiveAppletVideoStop;
	appletUid: string;
	timingChecksum: string;
	data: {
		uri: string;
		x: number;
		y: number;
		width: number;
		height: number;
	};
}

export const ActiveAppletVideoPause = 'Applet.ActiveAppletVideoPause';
export interface ActiveAppletVideoPause {
	type: typeof ActiveAppletVideoPause;
	appletUid: string;
	timingChecksum: string;
	data: {
		uri: string;
		x: number;
		y: number;
		width: number;
		height: number;
	};
}

export const ActiveAppletVideoResume = 'Applet.ActiveAppletVideoResume';
export interface ActiveAppletVideoResume {
	type: typeof ActiveAppletVideoResume;
	appletUid: string;
	timingChecksum: string;
	data: {
		uri: string;
		x: number;
		y: number;
		width: number;
		height: number;
	};
}
